$(document).ready(function($) {

  // GET HEADER HEIGHT

  let headerHeight = $('.new-header-wrapper').outerHeight(true);
  console.log("Header height",headerHeight);
  
  // SET MARGIN TOP ACCORDING TO INDEX PAGE AND OTHER PAGES
  let webMainContent = $('#MainContent');
  
  // GET PROMOBAR HEIGHT 

  let headerPromobar = $('.promobar-wrapper.promobar-main-wrap');
  let promobarHeight = $('.promobar-wrapper.promobar-main-wrap').outerHeight(true);
  let searchPageSection = $('.search-page-section');
  let collectionFilter = $('.new-collection-prod-grid-filter');
  let collectFilterGridheight = $('.new-collection-prod-grid-filter').outerHeight(true);
  searchPageSection.css({
      "opacity": "0" ,
      "visibility": "hidden"
  });
  
    if($('body').hasClass('main-page-wrap')){
      webMainContent.css('margin-top, 0');
    }else{
      webMainContent.css('margin-top', headerHeight);
    }

  // SIDE BAR SEARCH SCRIPT 

  // PROMOBAR SCRIPT 
  $('.promobar-wrapper.promobar-main-wrap').css('top', headerHeight);

  if($('body').hasClass('template-collection')){
    if(headerPromobar.length > 0){
      let parent = headerPromobar.parent();
      let sibling = parent.next();
      sibling.css('padding-top', promobarHeight);
      $('#new-collection-prod-products-faq-accord').css('top', collectFilterGridheight + headerHeight + promobarHeight);
    }
    else{
      $('#new-collection-prod-products-faq-accord').css('top', collectFilterGridheight + headerHeight);
    }
  }

  // NEW-COLLECTION PAGE "FILTER" FUNCTIONALITY STARTS
   $(".collection-prod-grid-filter").click(function(){
      event.stopPropagation();
    $("#new-collection-prod-products-faq-accord").toggleClass("close");
     $('body').toggleClass('scroll-off');
     $('.new-collection-prod-grid-item-warp').toggleClass('filter-overlay');
   });
  // NEW-COLLECTION PAGE "FILTER" FUNCTIONALITY ENDS

  // NEW-COLLECTION PAGE "FILTER-ACCORDION" FUNCTIONALITY STARTS
  // $('#new-collection-prod-products-faq-accord').find('.new-collection-prod-faq-accordion-toggle').click(function(){
  //   let isActive = $(this).hasClass("active");
  //   $('.new-collection-prod-faq-accordion-toggle').removeClass('active');
    
  //   if (!isActive) {
  //     $(this).toggleClass('active');
  //   }
  //   $(this).next().slideToggle();     
  //   $(".new-collection-prod-faq-accordion-content").not($(this).next()).slideUp();
  // });

   $(document).click(function() {
      let container = $("#new-collection-prod-products-faq-accord");
      let sizeGuidePopupContainer = $(".size_guide-popup_wrap");
     
     if (!container.is(event.target) && !container.has(event.target).length) {
       $("#new-collection-prod-products-faq-accord").removeClass("close");
       $('.new-collection-prod-grid-item-warp').removeClass('filter-overlay');
       $('body').removeClass('scroll-off');
      }
     if (!sizeGuidePopupContainer.is(event.target) && !sizeGuidePopupContainer.has(event.target).length) {
       $(".size_guide-popup_wrap").fadeOut();
       $('body').removeClass('popup-overlay');
     }

  });
  
  // NEW-COLLECTION PAGE "FILTER-ACCORDION" FUNCTIONALITY END

  // HEADER SIDE MENU BAR 

  $('.open-sidebar-onclick').click(function(){
    event.stopPropagation();
    $(this).closest('.header-inner').find('.left-side-menu-bar-wrap').toggleClass('open-sidebar');
    $(this).toggleClass('sidebar-btn-active');
    $('body').toggleClass('overlay-style');
    
    if($(this).hasClass('sidebar-btn-active')){
      $('body').removeClass('main-page-wrap');
      headerPromobar.css('display', 'none');
    }
    else{
      headerPromobar.css('display', 'block');
      if(!$('body').hasClass('other-page-wrap')){
        $('body').addClass('main-page-wrap');
      }
    }
    searchPageSection.css('top',headerHeight);


    // IF FILTER IS OPEN AND USER CLICKS ON HEADER MENUBAR THEN FILTER WILL CLOSE 
    
    if($('#new-collection-prod-products-faq-accord').hasClass('close')){
      $('#new-collection-prod-products-faq-accord').removeClass('close');
      $('.new-collection-prod-grid-item-warp').removeClass('filter-overlay');
      $('body').removeClass('scroll-off');
    }
      
    
  });
  $('.left-side-menu-bar-wrap').css('top', headerHeight);

  
  $(document).click(function() {
     let container = $("#left-side-menu-bar");
     let sidebarClickBtn = $('.open-sidebar-onclick');
    
    if(!container.is(event.target) && !container.has(event.target).length) {

      sidebarClickBtn.closest('.header-inner').find('.left-side-menu-bar-wrap').removeClass('open-sidebar');
      sidebarClickBtn.removeClass('sidebar-btn-active');
      $('body').removeClass('overlay-style');

      if(sidebarClickBtn.hasClass('sidebar-btn-active')){
        $('body').removeClass('main-page-wrap');
          headerPromobar.css('display', 'none');
        }
      else{
        headerPromobar.css('display', 'block');
        if(!$('body').hasClass('other-page-wrap')){
          $('body').addClass('main-page-wrap');
        }
      }
    }
  });
  
  // SIDEBAR SEARCH BUTTON CLICK 
  
  $('.search-container .header-search-btn').click(function(e){
    e.preventDefault();
     $('.search-wrap').addClass('is-show');
     searchPageSection.css({
        "opacity": "1" ,
        "visibility": "visible"
     });

    let q = $('#header-search-id').val().trim();
    let b = '&resources[type]=product';
    // console.log(q,"value");
    if (q === '' || q.toLowerCase() === 'search') {
      $('#searched-text').text("Search:");
    } else {
      $('#searched-text').text("Search: " + q);
    }

    $('#searched-text').text("Search: " + q);
   
    $.ajax('/search/suggest.json?q=' + q + b, {
      type: 'GET',
      dataType: 'json',
      success: function(response) {
        let productSuggestions = response.resources.results.products;
        let resultsContainer = $(".search-page-prod-grid-wrapp");

        resultsContainer.empty();
        if (q === '') {
          console.log("ajax if");
          resultsContainer.append('<div class="list-group-item list-group-item-action d-flex align-items-center"><small>Enter a search term</small></div>');
        } else if (productSuggestions.length > 0) {
          console.log("ajax else if");
          $(productSuggestions).each(function() {
            let productStatus = this.isSoldOut ? 'Sold Out' : this.price;
            resultsContainer.append('<div class="search-page-prod-item-imgbox"><a href="' + this.url + '" class="search-page-pro-item product" id="' + this.id + '"><div class="search-page-pro-img"><img src="' + this.featured_image.url + '" alt="" title=""></div><div class="search-page-prod-content"><h4 class="search-page-prod-title">' + this.title + '</h4><p class="search-page-prod-text">' + productStatus + '</p></div></a></div>');
          });
        } else {
          console.log("ajax else");
          resultsContainer.append('<div class="list-group-item list-group-item-action d-flex align-items-center"><small>No Results Found</small></div>');
        }
      },
      error: function(errorThrown){
        console.log(errorThrown);
         // if (!response || q === '' || q.toLowerCase() === 'search'){
         //   console.log(error, "Print the error");
         // }
      }   
    });

    $('#header-search-id').val(q);
  });

  $('#header-search-id').on('input', function() {
    console.log("input click");
    let inputText = $(this).val().trim();
    
    if (inputText === '') {
      $(this).val('');
      $(this).attr('placeholder', 'Search');
    }
  });
  
  $('.close_wrap').click(function(){
     $('.search-wrap').removeClass('is-show');
  });
  
  $('.search-close-btn-box').click(function(e){
     searchPageSection.css({
        "opacity": "0" ,
        "visibility": "hidden"
     });
  });
  
  // PRODUCT PAGE DETAIL SECTION FUNCTIONALITY 
  
  $('#products-faq-accord').find('.faq-accordion-toggle').click(function(){
    let isActive = $(this).hasClass("active");
    $('.faq-accordion-toggle').removeClass('active');
    
    if (!isActive) {
      $(this).toggleClass('active');
    }
    $(this).next().slideToggle();     
    $(".faq-accordion-content").not($(this).next()).slideUp();
  });
  
  // PRODUCT PAGE MOBILE SIZE GUIDE
  
  $('#mob-products-size-guide-accord').find('.size-accordion-toggle').click(function(){
    let isActive = $(this).hasClass("active");
    $('.size-accordion-toggle').removeClass('active');
    $('.size-guide-accord').removeClass('shadow-class');
    if (!isActive) {
      $(this).toggleClass('active');
      $('.size-guide-accord').addClass('shadow-class');
    }
    $(this).next().slideToggle('fast');     
    $(".size-accordion-content").not($(this).next()).slideUp('fast');
   
  });

  // COLLECTION PAGE "SHOW MORE PRODUCT" FUNCTIONALITY STARTS

  $(".new-collection-prod-grid-section .new-collection-prod-grid-item").slice(0, 8).show();
    $("body").on('click touchstart', '.new-collection-prod-grid-section .new-collection-prod-grid-more-btn', function (e) {
        e.preventDefault();
        $(".new-collection-prod-grid-section .new-collection-prod-grid-item:hidden").slice(0, 3).slideDown();
        if ($(".new-collection-prod-grid-section .new-collection-prod-grid-item:hidden").length == 0) {
            $(".new-collection-prod-grid-section .new-collection-prod-grid-more-btn").css('visibility', 'hidden');
        }
        $('html,body').animate({
            scrollTop: $(this).offset().top
        }, 1000);
    });
    // COLLECTION PAGE "SHOW MORE PRODUCT" FUNCTIONALITY ENDS
  
  // LOOKBOOK COLLECTION PAGE "SHOW MORE PRODUCT" FUNCTIONALITY STARTS
    $(".new-lookbook-collection-section .new-collection-prod-grid-item").slice(0, 8).show();
      $("body").on('click touchstart', '.new-lookbook-collection-section .new-collection-prod-grid-more-btn', function (e) {
          e.preventDefault();
          $(".new-lookbook-collection-section .new-collection-prod-grid-item:hidden").slice(0, 3).slideDown();
          if ($(".new-lookbook-collection-section .new-collection-prod-grid-item:hidden").length == 0) {
              $(".new-lookbook-collection-section .new-collection-prod-grid-more-btn").css('visibility', 'hidden');
          }
          $('html,body').animate({
              scrollTop: $(this).offset().top
          }, 1000);
    });

  // NEW-COLLECTION PAGE "Lookbook Gallery popup" FUNCTIONALITY STARTS
  $(".new-lookbook-collection-section .new-lookbook-prod-grid-item-main").click(function(){
    $(this).parent().next(".new-lookbook-prod-grid-popup-overlay").addClass("active");
    $(this).parent().next().find('.new-lookbook-prod-grid-popup-content').addClass("active");
    $("body").addClass("new-lookbook-prod-grid-popup_active");
  });
  
  $(".new-lookbook-collection-section .close").click(function(){
    $(this).parent().removeClass('active');
    $(this).parent().parent().removeClass('active');
    $("body").removeClass("new-lookbook-prod-grid-popup_active");
  });

  
// NEW-COLLECTION PAGE "Lookbook Gallery popup" SLIDER FUNCTIONALITY STARTS
  
  $(".popup-content-slider").slick({
     slidesToShow: 1,
     variableWidth: true,
     slidesToScroll: 1,
     infinite: false,
     autoplay: false,
     autoplaySpeed: 2000,
     prevArrow: '<button class="slick-prev"><svg id="west" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><rect id="Rettangolo_2003" data-name="Rettangolo 2003" width="20" height="20" fill="none"/><path id="Tracciato_1634" data-name="Tracciato 1634" d="M12.4,5,11.272,6.007l3.664,3.279H2v1.429H14.936l-3.672,3.279L12.4,15,18,10Z" transform="translate(0 -0.752)" fill="#000"/></svg></i></button>',
     nextArrow: '<button class="slick-next"><svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.2929 4.29289C12.6834 3.90237 13.3166 3.90237 13.7071 4.29289L20.7071 11.2929C21.0976 11.6834 21.0976 12.3166 20.7071 12.7071L13.7071 19.7071C13.3166 20.0976 12.6834 20.0976 12.2929 19.7071C11.9024 19.3166 11.9024 18.6834 12.2929 18.2929L17.5858 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H17.5858L12.2929 5.70711C11.9024 5.31658 11.9024 4.68342 12.2929 4.29289Z" fill="#000000"/></svg></button>',
     responsive: [
          {
            breakpoint: 720,
            settings: {
                variableWidth: false,
                infinite: false,
            }
          }
        ]
    });
  // NEW-COLLECTION PAGE "Lookbook Gallery popup" SLIDER FUNCTIONALITY END
  
   
    const hideSoldOutButton = document.getElementById("hideSoldOutButton");
    if (hideSoldOutButton) {
      hideSoldOutButton.addEventListener("click", function() {
        const products = document.querySelectorAll(".new-collection-prod-grid-item-warp .new-collection-prod-grid-item-main");
      
        products.forEach(function(product) {
          $('.new-collection-prod-grid-item.product-sold-out').css('display','none');
          console.log("Sold out Product testing");
        });
      });
    }

  // Popup opens on product page 
  
  $('.product-detail-wrap .size-guide-title, .mob-sticky-product-info .mob-size-guide-title').click(function(){
    event.stopPropagation();
    $('.size_guide-popup_wrap').addClass('show-popup');
      $(".size_guide-popup_wrap").fadeIn();
    $('body').addClass('popup-overlay');
  });

  $('.size_guide-popup_wrap .popup_close').click(function(){
    event.stopPropagation();
     $(".size_guide-popup_wrap").fadeOut();
     $('body').removeClass('popup-overlay');
  });
  
   // CART PAGE PRICE CHANGE ACCORDIONG TO INPUT QUANTITY

   let defaultQuantity = $(".cart-item__details .quantity__input");

  defaultQuantity.each(function(elem) {
    let baseQuantity = parseFloat($(this).val());
    let newQuantity = parseFloat($(this).val());

    let container = $(this).closest(".cart-item");
    let priceElement = container.find('.cart-price-change');
    let priceAttr = priceElement.data('base-price');
    let cleanedPriceAttr = priceAttr.replace('$', '').replace(',', '');
    let defaultPrice = parseFloat(cleanedPriceAttr);
    let basePrice;

    if (newQuantity === 0 || newQuantity === 1) {
        basePrice = defaultPrice;
    } else {
        basePrice = defaultPrice / baseQuantity;
    }

    $(this).on("input", function() {
        let newQuantity = parseFloat($(this).val());

        if (!isNaN(newQuantity) && newQuantity >= 0) {
            let newPrice = basePrice * newQuantity;
            priceElement.html('<span class="price__prefix">$</span>' + newPrice.toFixed(2));
            updateTotal();
        }
    });
  });
    // PRODUCT PAGE IMAGE SLIDER IN MOBILE ONLY
    mobileOnlySlider(".product-img-slider", false, true, 799);
 
});

function updateTotal() {
    var total = 0;
    $(".cart-price-change").each(function() {
        var price = parseFloat($(this).text().replace('$', '').replace(',', ''));
        total += price;
    });
    $(".totals__subtotal-value").text('$' + total.toFixed(2) + ' USD');
}


// DESKTOP PRODUCT SIZE OPTION BY DEFAULT FIRST CHECKED 
// const fieldsets = document.querySelectorAll('#products-size-guide-accord .variant-input-wrapper');
// console.log("fieldsets",fieldsets);
// fieldsets.forEach(fieldset => {
//   console.log(fieldset);
//   const firstRadio = fieldset.querySelector('#products-size-guide-accord input[type="radio"]');
//   firstRadio.setAttribute('checked', 'checked');
//   const label = fieldset.querySelector('#products-size-guide-accord label[for="' + firstRadio.id + '"]');
//   label.classList.add('desk-selected-label');
// });
/*
const inputs = document.querySelectorAll('#products-size-guide-accord input[type="radio"]');

inputs.forEach((input, index) => {
  if (index === 0) {
    input.setAttribute('checked', ''); // Set the first variant as checked by default
    const inputId = input.id;

    const matchingLabel = document.querySelector(`#products-size-guide-accord label[for="${inputId}"]`);
    if (matchingLabel) {
      matchingLabel.classList.add('checked');
    }
  }

  input.addEventListener('click', () => {
    inputs.forEach(otherInput => {
      if (otherInput === input) {
        input.setAttribute('checked', '');
        const inputId = input.id;

        const matchingLabel = document.querySelector(`.product-accord-style label[for="${inputId}"]`);
        if (matchingLabel) {
          matchingLabel.classList.add('checked');
        }
      } else {
        otherInput.removeAttribute('checked');
        const otherInputId = otherInput.id;

        const otherMatchingLabel = document.querySelector(`.product-accord-style label[for="${otherInputId}"]`);
        if (otherMatchingLabel) {
          otherMatchingLabel.classList.remove('checked');
        }
      }
    });
  });
});
*/

const fieldsets = document.querySelectorAll('#products-size-guide-accord fieldset');

fieldsets.forEach((fieldset, index) => {
  const inputs = fieldset.querySelectorAll('input[type="radio"]');
  
  // Select the first variant label by default on page load
  const firstInput = inputs[0];
  if (firstInput) {
    const inputId = firstInput.id;
    const matchingLabel = document.querySelector(`.product-accord-style label[for="${inputId}"]`);
    if (matchingLabel) {
      matchingLabel.classList.add('checked');
    }
  }

  inputs.forEach((input) => {
    input.addEventListener('click', () => {
      const inputId = input.id;
      const matchingLabel = document.querySelector(`.product-accord-style label[for="${inputId}"]`);

      if (matchingLabel) {
        // Remove 'checked' class from all labels in the same fieldset
        const labelsInFieldset = fieldset.querySelectorAll('.product-accord-style label');
        labelsInFieldset.forEach(label => label.classList.remove('checked'));

        // Add 'checked' class to the clicked label
        matchingLabel.classList.add('checked');
      }
    });
  });
});


// MOBILE PRODUCT SIZE OPTION BY DEFAULT FIRST CHECKED 
document.addEventListener('DOMContentLoaded', function() {
 const radioButtons = document.querySelectorAll('.mob-size-accordion-content input[type="radio"]');
  function updateStyling() {
    radioButtons.forEach(radioButton => {
      const label = radioButton.closest('label');
      if (radioButton.checked) {
        label.classList.add('selected-label');
      } else {
        label.classList.remove('selected-label');
      }
    });
  }
   radioButtons[0].checked = true;
   const firstLabel = radioButtons[0].closest('label');
   firstLabel.classList.add('selected-label');
   radioButtons.forEach(radioButton => {
    radioButton.addEventListener('change', updateStyling);
  });
  
  // Initial styling update
  updateStyling();
});

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  let slider = $($slidername);
  let settings = {
      mobileFirst: true,
      arrows: $arrows,
      infinite: false,
      prevArrow: '<button class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10"><path id="Tracciato_1634" data-name="Tracciato 1634" d="M12.4,5,11.272,6.007l3.664,3.279H2v1.429H14.936l-3.672,3.279L12.4,15,18,10Z" transform="translate(-2 -5)" fill="#fff"/></svg></button>',
      nextArrow: '<button class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10"><path id="Tracciato_1634" data-name="Tracciato 1634" d="M12.4,5,11.272,6.007l3.664,3.279H2v1.429H14.936l-3.672,3.279L12.4,15,18,10Z" transform="translate(-2 -5)" fill="#fff"/></svg></button>',
      responsive: [
          {
              breakpoint: $breakpoint,
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: true,
              settings: "unslick"
          }
      ]
  };

  slider.slick(settings);
  $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
          return;
      }
      if (!slider.hasClass("slick-initialized")) {
          return slider.slick(settings);
      }
  });
} 

// document.addEventListener('DOMContentLoaded', function() {
//   const fieldsets = document.querySelectorAll('.variant-input-wrapper');

//   fieldsets.forEach(fieldset => {
//     const radioInputs = fieldset.querySelectorAll('input[type="radio"]');
    
//     radioInputs.forEach(radioInput => {
//       radioInput.addEventListener('change', () => {
//         const labels = fieldset.querySelectorAll('label');
        
//         labels.forEach(label => {
//           label.classList.remove('desk-selected-label');
//         });
        
//         const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
//         const checkedLabel = fieldset.querySelector('label[for="' + checkedRadio.id + '"]');
        
//         if (checkedLabel) {
//           checkedLabel.classList.add('desk-selected-label');
//         }
//       });
//     });
//   });
// });
// LOOKBOOK POPUP SCRIPT
// $(".new-lookbook-prod-grid-item-main").click(function(){
//   $(".popup-content").addClass("active");
// });

// $(".popup-content .close").click(function(){
//   $(".popup-content").removeClass("active");
//   // $("body").removeClass("popup_active");
// });






